import React from "react";
import { useFormik } from "formik";

import DeviceGroupInputForm from "./DeviceGroupInputForm";

import { upsertDeviceGroup } from "app/services/report_templates/deviceGroupService";
import { DeviceGroupSchema } from "schemas/deviceGroupSchema";
import { showErrorToast, showSuccessToast } from "utils/toast";
import SideDrawerWrapper from "components/common/side-drawer/SideDrawerWrapper/SideDrawerWrapper";

const DeviceGroupModal = (props) => {
  const {
    show,
    isEditMode,
    selectedRow,
    onCloseModal,
    selectorsData,
    fetchDeviceGroups,
  } = props;

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      await upsertDeviceGroup(values, isEditMode);

      await fetchDeviceGroups();
      onCloseModal();
      resetForm();
      showSuccessToast("Device Group saved successfully");
    } catch (error) {
      showErrorToast(error?.message ?? error);
    } finally {
      setSubmitting(false);
    }
  };

  const formikProps = useFormik({
    initialValues: {
      _id: selectedRow?._id ?? "",
      name: selectedRow?.name ?? "",
      devices: selectedRow?.devices ?? [],
    },
    initialErrors: {},
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: DeviceGroupSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  const handleClose = () => {
    formikProps?.resetForm();
    onCloseModal();
  };

  const disabled = formikProps?.isSubmitting || !formikProps?.isValid;

  return (
    <SideDrawerWrapper
      showDrawer={show}
      handleClose={handleClose}
      title={isEditMode ? "Edit Device Group" : "Add Device Group"}
      titleStyle={{ fontWeight: 500, fontSize: 21 }}
      handleCancel={onCloseModal}
      cancelButtonText="Cancel"
      handleSubmit={
        formikProps?.isSubmitting ? null : formikProps?.handleSubmit
      }
      disableConfirm={disabled}
      disableCancel={disabled}
      successButtonText={formikProps?.isSubmitting ? "Saving..." : "Save"}
    >
      <DeviceGroupInputForm
        formikProps={formikProps}
        selectorsData={selectorsData}
        onCloseModal={onCloseModal}
      />
    </SideDrawerWrapper>
  );
};

export default DeviceGroupModal;
